export const SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_ACTION = "SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_ACTION";
export const SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_SUCCESS = "SUBSCRIPTION_CANCELATION_FEEDBACK_LIST_SUCCESS";

export const SUBSCRIPTION_CANCELATION_FEEDBACK_INIT = "SUBSCRIPTION_CANCELATION_FEEDBACK_INIT";
export const SUBSCRIPTION_CANCELATION_FEEDBACK_FAILED = "SUBSCRIPTION_CANCELATION_FEEDBACK_FAILED";
